module.exports = __webpack_public_path__ + "static/img/comprehensive-img.f7fe118.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/keyFeatures/comprehensive-img.png
// module id = S9k3
// module chunks = 0